import { JetpacB2BApi } from 'api' // NOTE: Assuming a B2B-specific API client exists. Please replace with the correct one.

class PaymentCollectionApi {
  static async getPaymentCollection(
    faberToken: string,
    params?: Record<string, string>
  ) {
    const queryString = params
      ? Object.entries(params)
          .filter(([, value]) => value && value.trim() !== '')
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      : ''
    return JetpacB2BApi.httpGet(
      `payment-allocation${queryString ? `?${queryString}` : ''}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static getUnpaidPaymentAllocation(
    faberToken: string,
    params?: Record<string, string>
  ) {
    const queryString = params
      ? Object.entries(params)
          .filter(([, value]) => value && value.trim() !== '')
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      : ''
    return JetpacB2BApi.httpGet(
      `invoice/unpaid${queryString ? `?${queryString}` : ''}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static getUnpaidPaymentAllocationById(faberToken: string, params?: string) {
    return JetpacB2BApi.httpGet(
      `payment-allocation/${params}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static addPaymentReceipt(
    faberToken: string,
    body: PaymentCollectionReceiptBackendData
  ) {
    return JetpacB2BApi.httpPost(
      'payment-allocation',
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default PaymentCollectionApi

export interface ITenantCatalogBackendData {
  tenant_id: string
  product_type: string
  catalog_group_id: string
  discount_percentage?: string
  is_active: boolean
  created_by: string
  tenant_catalog_group_discount: TenantCatalogGroupDiscount[]
}

export interface TenantCatalogGroupDiscount {
  catalog_group_id: string
  discount_percentage: string
}

export interface PaymentCollectionReceiptBackendData {
  tenant_id: string
  mode_of_payment: string
  reference_no: string
  allocation_remark: string
  product: string
  // is_active: true
  created_by: string
  payment_allocation_detail: PaymentAllocationDetailBackendData[]
}

export interface PaymentAllocationDetailBackendData {
  invoice_no: string
  order_id: string
  allocation_currency: string
  received_amount: number
  already_received: number
  booking_amount: number
  last_pending_amount: number
}
